import React from 'react';
import PropTypes from 'prop-types';

const icons = {
    'meds_icon': {
        path: [
            "M17.050 21.101h-1.425v-1.023l0.957-0.553c0.236-0.136 0.431-0.313 0.586-0.519 0.575 0.055 1.006 0.501 1.007 1.045-0.001 0.581-0.491 1.051-1.125 1.051zM12.78 21.114c-0.718 0.415-1.635 0.169-2.049-0.549s-0.169-1.635 0.549-2.049l3.507-2.025c0.717-0.415 1.635-0.169 2.049 0.549 0.415 0.717 0.169 1.634-0.549 2.049l-3.507 2.025zM17.416 18.565c0.228-0.559 0.203-1.218-0.125-1.788-0.559-0.968-1.783-1.308-2.733-0.76l-3.573 2.063c-0.95 0.548-1.267 1.779-0.709 2.747s1.783 1.309 2.734 0.76l0.066-0.037h4.149c0.815-0.001 1.475-0.673 1.475-1.501-0.001-0.761-0.561-1.388-1.285-1.484zM16.333 17.337c-0.293-0.507-0.993-0.651-1.563-0.321l-1.723 0.995 1.061 1.837 1.722-0.995c0.571-0.329 0.795-1.007 0.503-1.515z",
            "M18.063 15.775h3v0.656h-3v-0.656z",
            "M18.063 18.297c0.576 0.282 0.989 0.844 1.071 1.509h1.929v-3h-3v1.491z",
            "M20.313 13.432v-0.844h-2.625v0.844l-1.687 1.125v0.794c0.16 0.031 0.317 0.078 0.469 0.14v-0.746l1.782-1.125v-0.609h1.5v0.609l1.781 1.125v5.485c0 0.367-0.335 0.703-0.703 0.703h-1.889c-0.087 0.172-0.197 0.33-0.328 0.469h2.357c0.552 0 1.031-0.479 1.031-1.031v-5.813l-1.688-1.125z",
            "M17.687 12.101h2.625c0.243 0 0.45-0.167 0.45-0.413v-0.788h-3.525v0.787c0 0.246 0.207 0.413 0.45 0.413z",
            "M20.763 10.541c0-0.216-0.197-0.391-0.441-0.391h-2.643c-0.243 0-0.441 0.175-0.441 0.391v0.059h3.525v-0.059z",
        ],
        viewBox: "10 9 12 13",
    },
    'karie_k_icon': {
        path: [
            "M-361,265.9c0.8,0,1.4,0.6,1.4,1.4v25.2c0,0.6-0.2,1.2-0.6,1.6l-15.3,16.3c-0.2,0.2-0.4,0.3-0.6,0.3 c-0.4,0-0.8-0.3-0.8-0.8v-42.6c0-0.8,0.6-1.4,1.4-1.4H-361 M-361,263.9h-14.6c-1.9,0-3.4,1.5-3.4,3.4v42.6c0,1.6,1.3,2.8,2.8,2.8 c0.8,0,1.5-0.3,2-0.9l15.3-16.3c0.8-0.8,1.2-1.9,1.2-3v-25.2C-357.6,265.4-359.1,263.9-361,263.9L-361,263.9z",
            "M-321.3,287.4c1.3,0,2.1,1.7,1.1,2.7l-20,21.6c-1.1,1.4-1.2,2.6-0.3,4l21.7,32.2c0.4,0.7-0.1,2-0.9,2l-15.2,0 c0,0,0,0,0,0c-1.9,0-3.1,0-4.2-1.7l-12.4-18.5c-0.9-1.4-1.6-2-2.4-2c-0.7,0-1.4,0.5-2.2,1.4l-18.3,20c0,0-0.8,0.9-1.6,0.9 c-0.1,0-0.3,0-0.4-0.1c-0.9-0.4-0.6-1.2-0.6-1.8l0-18.7c0-0.8,0.9-2.2,0.9-2.2l36.4-38.9c0,0,0.9-0.9,3.5-0.9c0,0,0,0,0,0 L-321.3,287.4C-321.3,287.4-321.3,287.4-321.3,287.4 M-321.3,285.4L-321.3,285.4l-15,0c-3.1,0-4.5,1.1-5,1.6l0,0l-36.4,38.9 l-0.1,0.1l-0.1,0.2c-0.4,0.6-1.2,2-1.2,3.3l0,18.7c0,0.1,0,0.2,0,0.2c0,0.6-0.1,2.6,1.9,3.4c0.4,0.2,0.8,0.2,1.2,0.2 c1.6,0,2.8-1.2,3.1-1.5l18.3-20c0.3-0.4,0.6-0.6,0.7-0.7c0.2,0.1,0.4,0.4,0.8,1l12.3,18.5c1.7,2.5,3.8,2.5,5.8,2.5l15.3,0 c1,0,2-0.6,2.6-1.5c0.6-1.1,0.7-2.4,0.1-3.4l0-0.1l-0.1-0.1l-21.7-32.2c-0.4-0.5-0.5-0.8,0.1-1.6l19.9-21.5c1-1,1.3-2.5,0.7-3.8 C-318.6,286.2-319.9,285.4-321.3,285.4L-321.3,285.4z",
        ],
        viewBox: "-379 263.9 62.4 88.1",
    }
};

const Icon = props => {
    const ic = icons[props.icon];
    return (
        <svg style={{ ...props.style }} viewBox={ic.viewBox}>
            {
                ic.path && ic.path.length > 1 ?
                    ic.path.map(p => (<path d={p}></path>))
                    : <path d={icons[props.icon].path}></path>
            }
        </svg>
    )
};

Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
};

export default Icon;